"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInnerText = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _getInnerText = exports.getInnerText = function getInnerText(obj) {
  var buf = '';
  if (obj) {
    var type = _typeof(obj);
    if (type === 'string' || type === 'number') {
      buf += obj;
    } else if (type === 'object') {
      var children = null;
      if (Array.isArray(obj)) {
        children = obj;
      } else {
        var props = obj.props;
        if (props) {
          children = props.children;
        }
      }
      if (children) {
        if (Array.isArray(children)) {
          children.forEach(function (o) {
            buf += _getInnerText(o);
          });
        } else {
          buf += _getInnerText(children);
        }
      }
    }
  }
  return buf;
};